// @flow
import type { AxiosError, AxiosXHRConfig } from 'axios'
import type { ResponseError } from 'core/types'
import { Logger } from 'utils/logger'

const ApiLogger = Logger.get('ApiService')

const IGNORE_RETRY_STATUSES = [422, 401]

/**
 * Перехватчик отвалившегося запроса
 * @param {*} error
 */
export function ResponseInterceptorFail(error: {
  // flowlint-next-line unclear-type:off
  ...AxiosError<any>,
  // flowlint-next-line unclear-type:off
  config: AxiosXHRConfig<any> & { _retry?: boolean, ... },
  ...
}) {
  const { config = null, response = null } = error

  if (config === null || response === null) {
    ApiLogger.error(error)

    // Необходимо для любых внутренних ошибок axios (к примеру Cancel)
    return Promise.reject(error)
  }

  const originalRequest = config

  if (IGNORE_RETRY_STATUSES.includes(response.status)) {
    originalRequest._retry = true
  }

  // flowlint-next-line unclear-type:off
  const rejectData: ResponseError<any> = {
    status: response.status,
    statusText: response.statusText,
    errorText: error.toString(),
    headers: response.headers,
    ...(typeof response.data === 'object' ? response.data : { data: response.data }),
  }

  return Promise.reject(rejectData)
}
